import React from 'react';
import Bgsocial from '../images/social_prof.jpg';
import Stitle from '../images/social_prof_title.jpg';
import Bganswer from '../images/answer_burning.jpg';
import Seemore from './Seemore';


function LandingPageSocial() {
    
    return (
        <div class="max-w-12xl relative mx-auto bg-[#fefaee]">
            <img src={Bgsocial} className="w-full" style={{ height: 'auto' }} alt="" />
            <img src={Stitle} className="w-full" style={{ height: 'auto' }} alt="" />
            <div class="grid grid-cols-2 gap-4 bg-[#ffeb8c]">
                <div>
                    <section class="p-6 text-center md:p-12 md:text-left">
                        <div class="flex justify-center">
                            <div class="max-w-3xl">
                                <div class="m-4 block p-6">
                                    <div class="md:flex md:flex-row">
                                        <div
                                            class="mx-auto mb-6 flex w-36 items-center justify-center md:mx-0 md:w-96 lg:mb-0">
                                            <img
                                                src="https://tecdn.b-cdn.net/img/Photos/Avatars/img%20%2810%29.jpg"
                                                class="rounded-full shadow-md dark:shadow-black/30"
                                                alt="woman avatar" />
                                        </div>
                                        <div class="md:ms-6">
                                            <p class="mb-2 text-xl font-semibold text-neutral-800 dark:text-neutral-200">
                                                Anna Smith
                                            </p>
                                            <p
                                                class="mb-0 font-semibold text-neutral-500 dark:text-neutral-400">
                                                Product manager
                                            </p>
                                            <p class="mb-6 font-light text-neutral-500 dark:text-neutral-300">
                                                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Id
                                                quam sapiente molestiae numquam quas, voluptates omnis nulla
                                                ea odio quia similique corrupti magnam.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div>
                    <section class="p-6 text-center md:p-12 md:text-left">
                        <div class="flex justify-center">
                            <div class="max-w-3xl">
                                <div class="m-4 block p-6">
                                    <div class="md:flex md:flex-row">
                                        <div
                                            class="mx-auto mb-6 flex w-36 items-center justify-center md:mx-0 md:w-96 lg:mb-0">
                                            <img
                                                src="https://tecdn.b-cdn.net/img/Photos/Avatars/img%20%2810%29.jpg"
                                                class="rounded-full shadow-md dark:shadow-black/30"
                                                alt="woman avatar" />
                                        </div>
                                        <div class="md:ms-6">
                                            <p class="mb-2 text-xl font-semibold text-neutral-800 dark:text-neutral-200">
                                                Anna Smith
                                            </p>
                                            <p
                                                class="mb-0 font-semibold text-neutral-500 dark:text-neutral-400">
                                                Product manager
                                            </p>
                                            <p class="mb-6 font-light text-neutral-500 dark:text-neutral-300">
                                                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Id
                                                quam sapiente molestiae numquam quas, voluptates omnis nulla
                                                ea odio quia similique corrupti magnam.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <img src={Bganswer} className="w-full" style={{ height: 'auto' }} alt="" />
            <div class="max-w-screen-xl mx-auto px-5 min-h-sceen">
                <div class="grid divide-y divide-neutral-200 max-w-6xl mx-auto mt-8">
                    <div class="py-5">
                        <details class="group">
                            <summary class="flex justify-between items-center font-medium cursor-pointer list-none">
                                <span> What is a SAAS platform?</span>
                                <span class="transition group-open:rotate-180">
                                    <svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path>
                                    </svg>
                                </span>
                            </summary>
                            <p class="text-neutral-600 mt-3 group-open:animate-fadeIn">
                                SAAS platform is a cloud-based software service that allows users to access
                                and use a variety of tools and functionality.
                            </p>
                        </details>
                    </div>
                    <div class="py-5">
                        <details class="group">
                            <summary class="flex justify-between items-center font-medium cursor-pointer list-none">
                                <span> How does  billing work?</span>
                                <span class="transition group-open:rotate-180">
                                    <svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path>
                                    </svg>
                                </span>
                            </summary>
                            <p class="text-neutral-600 mt-3 group-open:animate-fadeIn">
                                We offers a variety of billing options, including monthly and annual subscription plans,
                                as well as pay-as-you-go pricing for certain services. Payment is typically made through a credit
                                card or other secure online payment method.
                            </p>
                        </details>
                    </div>
                    <div class="py-5">
                        <details class="group">
                            <summary class="flex justify-between items-center font-medium cursor-pointer list-none">
                                <span> Can I get a refund for my subscription?</span>
                                <span class="transition group-open:rotate-180">
                                    <svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path>
                                    </svg>
                                </span>
                            </summary>
                            <p class="text-neutral-600 mt-3 group-open:animate-fadeIn">
                                We offers a 30-day money-back guarantee for most of its subscription plans. If you are not
                                satisfied with your subscription within the first 30 days, you can request a full refund. Refunds
                                for subscriptions that have been active for longer than 30 days may be considered on a case-by-case
                                basis.
                            </p>
                        </details>
                    </div>
                    <div class="py-5">
                        <details class="group">
                            <summary class="flex justify-between items-center font-medium cursor-pointer list-none">
                                <span> How do I cancel my subscription?</span>
                                <span class="transition group-open:rotate-180">
                                    <svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path>
                                    </svg>
                                </span>
                            </summary>
                            <p class="text-neutral-600 mt-3 group-open:animate-fadeIn">
                                To cancel your We subscription, you can log in to your account and navigate to the
                                subscription management page. From there, you should be able to cancel your subscription and stop
                                future billing.
                            </p>
                        </details>
                    </div>
                    <div class="py-5">
                        <details class="group">
                            <summary class="flex justify-between items-center font-medium cursor-pointer list-none">
                                <span> Can I try this platform for free?</span>
                                <span class="transition group-open:rotate-180">
                                    <svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path>
                                    </svg>
                                </span>
                            </summary>
                            <p class="text-neutral-600 mt-3 group-open:animate-fadeIn">
                                We offers a free trial of its  platform for a limited time. During the trial period,
                                you will have access to a limited set of features and functionality, but you will not be charged.
                            </p>
                        </details>
                    </div>
                    <div class="py-5">
                        <details class="group">
                            <summary class="flex justify-between items-center font-medium cursor-pointer list-none">
                                <span> How do I access   documentation?</span>
                                <span class="transition group-open:rotate-180">
                                    <svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path>
                                    </svg>
                                </span>
                            </summary>
                            <p class="text-neutral-600 mt-3 group-open:animate-fadeIn">
                                Documentation is available on the company's website and can be accessed by
                                logging in to your account. The documentation provides detailed information on how to use the ,
                                as well as code examples and other resources.
                            </p>
                        </details>
                    </div>
                    <div class="py-5">
                        <details class="group">
                            <summary class="flex justify-between items-center font-medium cursor-pointer list-none">
                                <span> How do I contact support?</span>
                                <span class="transition group-open:rotate-180">
                                    <svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path>
                                    </svg>
                                </span>
                            </summary>
                            <p class="text-neutral-600 mt-3 group-open:animate-fadeIn">
                                If you need help with the platform or have any other questions, you can contact the
                                company's support team by submitting a support request through the website or by emailing
                                support@We.com.
                            </p>
                        </details>
                    </div>
                    <div class="py-5">
                        <details class="group">
                            <summary class="flex justify-between items-center font-medium cursor-pointer list-none">
                                <span> Do you offer any discounts or promotions?</span>
                                <span class="transition group-open:rotate-180">
                                    <svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path>
                                    </svg>
                                </span>
                            </summary>
                            <p class="text-neutral-600 mt-3 group-open:animate-fadeIn">
                                We may offer discounts or promotions from time to time. To stay up-to-date on the latest
                                deals and special offers, you can sign up for the company's newsletter or follow it on social media.
                            </p>
                        </details>
                    </div>
                    <div class="py-5">
                        <details class="group">
                            <summary class="flex justify-between items-center font-medium cursor-pointer list-none">
                                <span> How do we compare to other similar services?</span>
                                <span class="transition group-open:rotate-180">
                                    <svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path>
                                    </svg>
                                </span>
                            </summary>
                            <p class="text-neutral-600 mt-3 group-open:animate-fadeIn">
                                This platform is a highly reliable and feature-rich service that offers a wide range
                                of tools and functionality. It is competitively priced and offers a variety of billing options to
                                suit different needs and budgets.
                            </p>
                        </details>
                    </div>
                </div>
            </div>

            <div class="max-w-screen-xl mx-auto" style={{ backgroundImage: "url('https://dev.galenium.com/assets/media/images/sample/lp_footer.jpg')", height: "180px", backgroundRepeat: "no-repeat" }}>
                <Seemore />
            </div>
        </div>
    );
}

export default LandingPageSocial;
